import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MainPipeModule } from '@app/helpers';
import { I18nModule } from 'haba-core';
import { ProductDetailsPriceDisplayComponent } from './product-detail/product-details-price-display/product-details-price-display.component';

@NgModule({
  exports: [ProductDetailsPriceDisplayComponent],
  imports: [
    RouterModule,
    CommonModule,
    MainPipeModule,
    I18nModule,
    ProductDetailsPriceDisplayComponent,
  ],
})
export class ProductDetailsPriceDisplayModule {}
